import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

// Figma "icons / system" arrow_outward, drawn on a 12px grid: a link that leaves the page.
export const ArrowUpRight = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-small", className)}
  >
    <path
      d="M3.33847 9.5L2.5 8.66153L7.46729 3.69425H3.05631V2.5H9.5V8.94369H8.30575V4.53272L3.33847 9.5Z"
      fill="currentColor"
    />
  </svg>
);
